import { provideAppInitializer } from '@angular/core';

export const PENDING_CREDENTIAL_KEY = 'fido:pendingOAuthCredential';
export const PENDING_CREDENTIAL_TTL_MS = 30 * 60 * 1000;

export function isEnvelopeExpired(raw: string): boolean {
  try {
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) {
      return true;
    }
    const envelope = parsed as Record<string, unknown>;
    const { credential, storedAt, email } = envelope;
    if (
      typeof credential !== 'object' ||
      credential === null ||
      typeof storedAt !== 'number' ||
      !Number.isFinite(storedAt) ||
      typeof email !== 'string'
    ) {
      return true;
    }
    const now = Date.now();
    if (storedAt > now) {
      return true;
    }
    return now - storedAt >= PENDING_CREDENTIAL_TTL_MS;
  } catch {
    return true;
  }
}

export function providePendingCredentialCleanup() {
  return provideAppInitializer(() => {
    const raw = localStorage.getItem(PENDING_CREDENTIAL_KEY);
    if (raw && isEnvelopeExpired(raw)) {
      localStorage.removeItem(PENDING_CREDENTIAL_KEY);
    }
  });
}
